class PhpDateTime extends Date {
  static weekDays = [7, 1, 2, 3, 4, 5, 6]
  static shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  static longDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  static daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  static amPmClock = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

  static shortMonths = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]

  static longMonths = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ]

  static Format (date, formatString) {
    let returnString = ''
    let explodedFormat = formatString.split('')
    let escapedExplodedFormat = []

    for (let i = 0, j = 1; i < explodedFormat.length; i++, j++) {
      if (explodedFormat[i] === '\\' && typeof explodedFormat[j] !== 'undefined') {
        escapedExplodedFormat.push(explodedFormat[i] + explodedFormat[j])
        i++
        j++
      } else {
        escapedExplodedFormat.push(explodedFormat[i])
      }
    }
    if (escapedExplodedFormat.length !== 0) {
      explodedFormat = [...escapedExplodedFormat]
    }

    for (let i = 0; i < explodedFormat.length; i++) {
      let exception = null
      let timePart = null
      switch (explodedFormat[i]) {
        case 'd':
          timePart = this.padLeftToLength(date.getDate().toString(), 2, '0')
          break
        case 'D':
          timePart = this.shortDays[date.getDay()]
          break
        case 'j':
          timePart = date.getDate().toString()
          break
        case 'l':
          timePart = this.longDays[date.getDay()]
          break
        case 'N':
          timePart = this.getWeekDay(date.getDay()).toString()
          break
        case 'S':
          timePart = this.englishDayOfMonthSuffix(date.getDate())
          break
        case 'w':
          timePart = date.getDay().toString()
          break
        case 'z':
          timePart = this.calculateDayOfTheYear(date).toString()
          break
        case 'W':
          timePart = this.padLeftToLength(this.iso8601weekNumberOfDate(date).toString(), 2, '0')
          break
        case 'F':
          timePart = this.longMonths[date.getMonth()]
          break
        case 'm':
          timePart = this.padLeftToLength((1 + date.getMonth()).toString(), 2, '0')
          break
        case 'M':
          timePart = this.shortMonths[date.getMonth()]
          break
        case 'n':
          timePart = (1 + date.getMonth()).toString()
          break
        case 't':
          timePart = this.calculateDaysInMonth(date.getMonth(), date.getFullYear()).toString()
          break
        case 'L':
          timePart = this.isLeapYear(date.getFullYear()) ? '1' : '0'
          break
        case 'o':
          timePart = this.iso8601Year(date).toString()
          break
        case 'Y':
          timePart = date.getFullYear().toString()
          break
        case 'y':
          timePart = date.getFullYear().toString().substr(2, 2)
          break
        case 'a':
          timePart = this.amPmFormat(date.getHours())
          break
        case 'A':
          timePart = this.amPmFormat(date.getHours()).toUpperCase()
          break
        case 'B':
          timePart = this.padLeftToLength(this.calculateSwatchInternetTime(date).toString(), 3, '0')
          break
        case 'g':
          timePart = this.amPm24to12hourConversion(date.getHours()).toString()
          break
        case 'G':
          timePart = date.getHours().toString()
          break
        case 'h':
          timePart = this.padLeftToLength(this.amPm24to12hourConversion(date.getHours()).toString(), 2, '0')
          break
        case 'H':
          timePart = this.padLeftToLength(date.getHours().toString(), 2, '0')
          break
        case 'i':
          timePart = this.padLeftToLength(date.getMinutes().toString(), 2, '0')
          break
        case 's':
          timePart = this.padLeftToLength(date.getSeconds().toString(), 2, '0')
          break
        case 'u':
          exception = new Error('"u" - Microseconds. Not implemented due to how JS works')
          break
        case 'v':
          timePart = this.padLeftToLength(date.getMilliseconds().toString(), 3, '0')
          break
        case 'e':
          exception = new Error('"e" - Timezone identifier. Not implemented due to how JS date works')
          break
        case 'I':
          exception = new Error('"I" - Daylight Saving Time. Not implemented due to how JS date works')
          break
        case 'O':
          timePart = this.timeZoneFormatO(date.getTimezoneOffset())
          break
        case 'P':
          timePart = this.timeZoneFormatP(date.getTimezoneOffset())
          break
        case 'p':
          if (date.getTimezoneOffset() === 0) {
            timePart = 'z'
          } else {
            timePart = this.timeZoneFormatP(date.getTimezoneOffset())
          }
          break
        case 'T':
          exception = new Error('"T" - Timezone abbreviation. Not implemented due to how JS date works')
          break
        case 'Z':
          timePart = (date.getTimezoneOffset() * 60).toString()
          break
        case 'c':
          timePart = this.Format(date, 'Y-m-d\\TH:i:sP')
          break
        case 'r':
          timePart = this.Format(date, 'D, d M Y H:i:s O')
          break
        case 'U':
          timePart = Math.round(date.getTime() / 1000).toString()
          break
        default:
          if (explodedFormat[i][0] === '\\' && explodedFormat[i].length !== 1) {
            timePart = explodedFormat[i][1]
          } else if (explodedFormat[i][0] !== '\\') {
            timePart = explodedFormat[i]
          } else {
            timePart = ''
          }
          break
      }

      if (exception !== null) {
        throw exception
      }

      returnString += timePart
    }

    return returnString
  }

  static iso8601numberOfWeeksInYear (year) {
    let weeks = 52
    const years = [year, year - 1]
    const pYears = years.map(value => {
      return (value + Math.floor(value / 4) - Math.floor(value / 100) + Math.floor(value / 400)) % 7
    })

    if (pYears[0] === 4 || pYears[1] === 3) {
      weeks += 1
    }

    return weeks
  }

  static iso8601weekNumberOfDate (date) {
    let week = (10 + this.calculateDayOfTheYear(date) - this.getWeekDay(date.getDay())) / 7
    week = Math.floor(week)

    if (week < 1) {
      week = this.iso8601numberOfWeeksInYear(date.getFullYear() - 1)
    } else if (week > this.iso8601numberOfWeeksInYear(date.getFullYear())) {
      week = 1
    }

    return week
  }

  static iso8601Year (date) {
    let returnYear = date.getFullYear()
    let week = (10 + this.calculateDayOfTheYear(date) - this.getWeekDay(date.getDay())) / 7
    week = Math.floor(week)

    if (week < 1) {
      returnYear = date.getFullYear() - 1
    } else if (week > this.iso8601numberOfWeeksInYear(date.getFullYear())) {
      returnYear = date.getFullYear() + 1
    }

    return returnYear
  }

  static padLeftToLength (inputString, length, paddingCharacter) {
    while (inputString.length < length) {
      inputString = paddingCharacter + inputString
    }
    return inputString
  }

  static timeZoneFormatO (offset) {
    const fullHours = Math.floor(Math.abs(offset) / 60)
    const minutes = Math.abs(offset % 60)
    return (offset < 0 ? '-' : '+') +
      this.padLeftToLength(fullHours.toString(), 2, '0') +
      this.padLeftToLength(minutes.toString(), 2, '0')
  }

  static timeZoneFormatP (offset) {
    const fullHours = Math.floor(Math.abs(offset) / 60)
    const minutes = Math.abs(offset % 60)
    return (offset < 0 ? '-' : '+') +
      this.padLeftToLength(fullHours.toString(), 2, '0') +
      ':' + this.padLeftToLength(minutes.toString(), 2, '0')
  }

  static amPmFormat (hour) {
    return hour < 12 ? 'am' : 'pm'
  }

  static isLeapYear (year) {
    if (year % 4 !== 0) {
      return false
    } else if (year % 100 !== 0) {
      return true
    } else if (year % 400 !== 0) {
      return false
    }
    return true
  }

  static englishDayOfMonthSuffix (day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st'
      case 2:
      case 22:
        return 'nd'
      case 3:
      case 23:
        return 'rd'
      default:
        return 'th'
    }
  }

  static calculateDaysInMonth (month, year) {
    let returnValue = this.daysInMonths[month]
    if (month === 1 && this.isLeapYear(year)) {
      returnValue += 1
    }
    return returnValue
  }

  static calculateDayOfTheYear (date) {
    let day = 0
    for (let i = 0; i < date.getMonth(); i++) {
      day += this.calculateDaysInMonth(i, date.getFullYear())
    }
    day += date.getDate()
    return day
  }

  static getWeekDay (dayNumber) {
    return this.weekDays[dayNumber]
  }

  static calculateSwatchInternetTime (date) {
    return Math.floor(
      (((date.getUTCHours() + 1) % 24) + date.getUTCMinutes() / 60 + date.getUTCSeconds() / 3600) * 1000 / 24
    )
  }

  static amPm24to12hourConversion (hour) {
    return this.amPmClock[hour]
  }

  format (formatString) {
    return PhpDateTime.Format(this, formatString)
  }
}

export default PhpDateTime



// WEBPACK FOOTER //
// ./src/assets/js/Helpers/PhpDateTime.js